import {Action} from '@ngrx/store'
import {StudySite} from '../model_temp/studysite.model';

export const update_SiteSetup = 'Update_SiteSetup';
export const update_SiteSetup_Success = 'Update_SiteSetup_Success';
// export const Load_Site = 'Load_Site';
// export const Clear_SiteState ='Clear_SiteState'

//update study site details to store
export class UpdateSiteSetupSuccesss implements Action {
    readonly type = update_SiteSetup_Success;

    constructor(public payload: StudySite) {

    }

}


//update study site details to session
export class UpdateSiteSetup implements Action {
    readonly type = update_SiteSetup;

    constructor(public payload: StudySite) {
    }

}

//load study site details to store on page refresh
// export class LoadSite implements Action {
//     readonly type = Load_Site;

//     constructor() {

//     }

// }

// export class ClearSiteState implements Action {
//     readonly type = Clear_SiteState;

//     constructor() {

//     }

// }

export type Actions = UpdateSiteSetupSuccesss |
    UpdateSiteSetup ;